import React, { useState, useEffect } from 'react';
import StudentApp from './StudentApp';
import AppAdmin from './AppAdmin';

function App() {
  const [currentRoute, setCurrentRoute] = useState(window.location.hash + window.location.pathname);

  useEffect(() => {
    const onRouteChange = () => setCurrentRoute(window.location.hash + window.location.pathname);
    window.addEventListener('hashchange', onRouteChange);
    window.addEventListener('popstate', onRouteChange);
    return () => {
        window.removeEventListener('hashchange', onRouteChange);
        window.removeEventListener('popstate', onRouteChange);
    };
  }, []);

  if (currentRoute.toLowerCase().includes('admin')) {
    return <AppAdmin />;
  }

  return <StudentApp />;
}

export default App;